import React, {
  useCallback,
  useState,
  useEffect,
} from 'react'
import EmailInput from '@active/react-ui/EmailInput'
import Alert from '@active/react-ui/Alert'
import { isEmail } from '@active/core/email/validate'
import noop from 'lodash/noop'
import I18nMessage from '../I18nMessage'
import injectServices from '../../../shared/service/injectServices'
import { useCommonContext } from '../../../widgets/widgetCommonContext'
import emailServiceConfig from './email.service.json'
import './EmailInputWithBadListCheck.scss'

const EmailInputWithBadListCheckCom = function ({
  services: {
    checkEmail: checkEmailService,
  },
  onBlur,
  remoteCheck = true,
  isShowWarning: defaultShowWarning,
  tipContent,
  ...rest
}) {
  const [isShowWarning, setIsShowWarning] = useState(false)

  const checkEmail = useCallback(
    value => {
      isEmail(value) && checkEmailService({
        params: { email: value },
        show: noop,
        hide: noop,
        resolve: ({ valid }) => {
          if (valid) {
            setIsShowWarning(false)
          } else {
            setIsShowWarning(true)
          }
        },
        reject: () => {
          console.error('Validation failed')
        },
      })
    }, [checkEmailService])

  const handleBlur = useCallback(e => {
    remoteCheck && checkEmail(e.target.value)
    onBlur?.(e)
  }, [onBlur])

  useEffect(() => {
    setIsShowWarning(defaultShowWarning)
  }, [defaultShowWarning])

  return (
    <div>
      <EmailInput
        {...rest}
        onBlur={handleBlur}
      />
      {isShowWarning && (
        <Alert
          type="warning"
          theme="inline"
          className="email-typo-warning"
        >
          <div>
            <I18nMessage id="passport.common.text.typoTip.title" />
          </div>
          <div className="tip-content">
            <I18nMessage id={tipContent || 'passport.common.text.typoTip.content'} />
          </div>
        </Alert>
      )}
    </div>
  )
}

const EmailInputWithBadListCheck = injectServices(emailServiceConfig)(EmailInputWithBadListCheckCom)

export default function (props) {
  const {
    passportAPIServerHost,
  } = useCommonContext()

  return <EmailInputWithBadListCheck passportAPIServerHost={passportAPIServerHost} {...props} />
}
